<template>
  <div id="search_div" style="margin-top:20px;">
    <div class="row">
      <div class="col-md-8">
        <annotated-image
            :zoom_enabled="true"
            :sensitive-blur="sensitiveBlurForLoadedAsset"
            :image_url="asset_url"
            :annotations="annotations"
            @update_coords="updateAnnotation"
            @delete_annotation="deleteAnnotation"
            @select="selectAnnotation"
            @unselect="unselectAnnotation"
        ></annotated-image>
      </div>
      <div class="col-md-4">

        <div class="row">
          <div class="col-md-12">
          <annotate-labels @add_annotation="addAnnotation" :type="'box'"></annotate-labels>
          <annotate-labels @add_annotation="addAnnotation" :type="'point'"></annotate-labels>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <annotations-list
                @clear="clearAnnotations"
                @select="selectAnnotation"
                @unselect="unselectAnnotation" :annotations="annotations"></annotations-list>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <hr />
          </div>
        </div>

        <div v-if="original_category" style="margin-top: 10px">
          Original category: <br />
          {{original_category}}
        </div>

        <annotate-buttons
          :asset_id="asset_id"
          :annotations="annotations"
          :asset_id_history="asset_id_history"
        ></annotate-buttons>
      </div>
    </div>
  </div>
</template>

<script>
import AnnotatedImage from "@/components/AnnotatedImage";
import AnnotateMixin from "@/mixins/AnnotateMixin";
import Annotation from "@/classes/annotation";
import AnnotationsList from "@/components/AnnotationsList";
import AnnotateLabels from "@/components/AnnotateLabels";
import AnnotateButtons from "@/components/AnnotateButtons";
import LoadSettingsMixin from "@/mixins/LoadSettingsMixin";
import CurrentUserMixin from "@/mixins/CurrentUserMixin.vue";
import {
  getBlurUnlessMetaFromSettings,
  shouldBlurAssetMeta,
} from '@/utils/sensitiveImageBlur';
export default {
  name: "CheckModel",
  components: {AnnotateButtons, AnnotateLabels, AnnotationsList, AnnotatedImage},
  mixins: [AnnotateMixin, LoadSettingsMixin, CurrentUserMixin],
  props: {
    'asset_id': {required: true}
  },
  data () {
    return {
      'canvas_id': 'custom_id',
      'find_meta_contains': '',
      'find_original_category': '',
      'original_category': '',
      'asset_id_history': [],
      'asset_url': false,
    }
  },
  mounted () {
    this.load();
    window.addEventListener('keydown', this.addEvents);
  },
  computed: {
    sensitiveBlurForLoadedAsset() {
      const policy = getBlurUnlessMetaFromSettings(this.settings || []);
      let metaStr = '';
      if (this.meta && typeof this.meta === 'object') {
        metaStr = JSON.stringify(this.meta);
      } else if (typeof this.meta === 'string') {
        metaStr = this.meta;
      }
      return shouldBlurAssetMeta(metaStr, policy, this.is_sensitive_image_blur_exempt);
    },
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.addEvents);
  },
  methods: {
    addEvents: function(e) {
        if(e.keyCode === 13) { //enter
          e.stopPropagation();
          e.preventDefault();
          this.isCorrect();
        }
        if(e.keyCode === 8) { // delete
          let annotations = this.annotations.filter(annotation=>{return !annotation.selected})
          this.annotations = annotations;
        }
        if(e.keyCode === 39) { // arrow right
          if(this.annotation_selected) {
            console.log('TODO move to the right');
          }
        }
      },
      async load() {
          this.loading = true;

          let result = await this.$api.model.get_preds(this.asset_id)
          let annotations = result.annotations
          let i = 0;
          annotations = annotations.map(annotation=>{
            let id = this.getUniqueId();
            let color = result.colors[i]; i += 1;
            return new Annotation(id, 'box', annotation.coords, annotation.conf, annotation.label, color);
          });
          this.annotations = []
          this.asset_url = result.path
          this.annotations = annotations
          this.loading = false
        
    }
  }
}
</script>

<style scoped>

</style>